import { ApiParams } from 'services/cdmApi';
import { ErrorModel, CdmTranslationModel } from 'models';

export function requestCdmTranslation(keys: (keyof CdmTranslationModel)[], params?: ApiParams) {
  return {
    type: requestCdmTranslation.type,
    payload: {
      keys,
      params,
    },
  } as const;
}

requestCdmTranslation.type = 'cdmTranslation/request' as const;

export function receiveCdmTranslation(data: CdmTranslationModel) {
  return {
    type: receiveCdmTranslation.type,
    payload: {
      data,
    },
  } as const;
}

receiveCdmTranslation.type = 'cdmTranslation/receive' as const;

export function errorCdmTranslation(error: ErrorModel) {
  return {
    type: errorCdmTranslation.type,
    payload: {
      error,
    },
  } as const;
}

errorCdmTranslation.type = 'cdmTranslation/error' as const;
